import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { importarCSV } from '../services/api';
import { useAuthValidation } from '../hooks/useAuthValidation';

const ImportCSV = () => {
  useAuthValidation();
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setResult(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      toast.error('Por favor seleccione un archivo CSV');
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);

      const data = await importarCSV(formData);
      setResult(data);

      if (data.success) {
        toast.success(`Importación completada: ${data.processed} comprobantes procesados`);
      }
    } catch (error) {
      console.error('Error importando CSV:', error);
      toast.error(error.response?.data?.error || 'Error al importar archivo');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="import-csv">
      <h3>Importar Comprobantes desde CSV</h3>

      <div className="card shadow-sm mt-4">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="archivo" className="form-label">
                Archivo CSV *
              </label>
              <input
                type="file"
                className="form-control"
                id="archivo"
                accept=".csv"
                onChange={handleFileChange}
                required
              />
              <div className="form-text">
                El archivo debe estar en formato CSV con las columnas correctas
              </div>
            </div>

            <div className="mb-3">
              <button
                type="submit"
                className="btn btn-primary me-2"
                disabled={loading || !file}
              >
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                    ></span>
                    Importando...
                  </>
                ) : (
                  <>
                    <i className="bi bi-upload"></i> Importar
                  </>
                )}
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => navigate('/')}
              >
                Volver
              </button>
            </div>
          </form>

          {/* Results */}
          {result && (
            <div className={`alert ${result.success ? 'alert-success' : 'alert-warning'} mt-4`}>
              <h5>Resultado de Importación</h5>
              <ul>
                <li>Procesados: {result.processed}</li>
                {result.errors > 0 && <li>Errores: {result.errors}</li>}
                {result.skipped > 0 && <li>Omitidos: {result.skipped}</li>}
              </ul>

              {result.error_details && result.error_details.length > 0 && (
                <div className="mt-3">
                  <h6>Detalles de Errores:</h6>
                  <div className="table-responsive" style={{ maxHeight: '300px', overflow: 'auto' }}>
                    <table className="table table-sm">
                      <thead>
                        <tr>
                          <th>Fila</th>
                          <th>Error</th>
                        </tr>
                      </thead>
                      <tbody>
                        {result.error_details.map((error, idx) => (
                          <tr key={idx}>
                            <td>{error.row}</td>
                            <td>{error.error}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Instructions */}
      <div className="card shadow-sm mt-4">
        <div className="card-header bg-info text-white">
          <h5 className="mb-0">Instrucciones de Formato CSV</h5>
        </div>
        <div className="card-body">
          <p>El archivo CSV debe contener las siguientes columnas (en orden):</p>
          <ol>
            <li>ruc (sin dígito verificador)</li>
            <li>numero_timbrado</li>
            <li>tipo_comprobante</li>
            <li>fecha_comprobante (YYYY-MM-DD)</li>
            <li>numero_comprobante</li>
            <li>monto_gravado_10</li>
            <li>monto_gravado_5</li>
            <li>monto_exento</li>
            <li>monto_total</li>
            <li>imputa_iva (S/N)</li>
            <li>imputa_ire (S/N)</li>
            <li>imputa_irp_rsp (S/N)</li>
          </ol>
          <p className="mb-0">
            <strong>Ejemplo:</strong>
            <br />
            <code>
              2902466,12345678,109,2025-12-26,001-001-0000001,100000,50000,25000,175000,S,N,N
            </code>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ImportCSV;
